import { DateModel } from "../../../../shared/models/date.model";
import { TimePeriod } from "../../../../shared/enums/timePeriods.enum";
import { HeatmapType } from "../../../../shared/enums/heatmapType.enum";
import { WorkingEfficiency } from "../models/efficiency.model";

export interface loadEfficiencyInitialState {
    loadEfficiency: WorkingEfficiency | null;
    organizations: string[];
    companies: string[];
    departments: string[];
    forklits: string[];
    tags: string[];
    models: string[];
    activities: string[];
    dates: DateModel;
    period: TimePeriod;
    heatmapType: HeatmapType;
    showFilters: boolean;
    shifts: any[];
    weeklyWorkingHours: number;
    monthlyWorkingHours: number;
}

const initialLoadEfficiency: loadEfficiencyInitialState = {
    loadEfficiency: null,
    organizations: [],
    companies: [],
    departments: [],
    forklits: [],
    tags: [],
    models: [],
    activities: [],
    dates: {
        startDate: null,
        endDate: null
    },
    period: TimePeriod.Daily,
    heatmapType: HeatmapType.Hourly,
    showFilters: true,
    shifts: [],
    weeklyWorkingHours: 168,
    monthlyWorkingHours: 720
}

export default initialLoadEfficiency
